export enum VisualizationSourceType {
  Gltf = 'gltf',
  Url = 'url',
  DrillPatternJson = 'drillPatternJson',
}